import { Outlet } from 'react-router-dom'

import { InvoicesPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import DataTableWrapper from 'modules/finance/components/Invoices/DataTableWrapper'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const InvoicesPage = () => {
  const { data, loading: loadingQuery, error } = useQuery(InvoicesPageDocument, {})

  const currencies = data ? data.apiCore.currenciesConnection.edges.map((edge) => edge.node) : []

  const canManagePurchaseFinancialDocuments =
    data?.finance?._policies?.financialDocumentsManagePurchase?.can ?? false
  const canCreatePurchaseFinancialDocuments =
    data?.finance?._policies?.financialDocumentsCreatePurchase?.can ?? false
  const legalEntitiesOptions =
    data?.companies.legalEntitiesConnection.nodes.map((legalEntity) => ({
      label: legalEntity.legalName || '',
      value: legalEntity.id,
    })) || []
  const financialDocumentsPaymentsAvailable =
    data?.companies.featureAvailability?.available ?? false

  return (
    <ResponsivePage.Body
      error={error}
      loading={loadingQuery}
      authorized={canManagePurchaseFinancialDocuments}
    >
      <Outlet />
      <DataTableWrapper
        currencies={currencies}
        financialDocumentsPaymentsAvailable={financialDocumentsPaymentsAvailable}
        legalEntities={legalEntitiesOptions}
        canCreatePurchaseFinancialDocuments={canCreatePurchaseFinancialDocuments}
      />
    </ResponsivePage.Body>
  )
}

export default InvoicesPage
